<template>
  <div :style="`width:${dispW}px; height:${dispH}px;position:relative;left:0px;top:0px;`">
    <div :style="`position:absolute;top:100px;left:130px;width:${dispW - 300}px;`">
      <ZernikePyramid @show-waiting="showWaiting" />
    </div>
    <div style="position: absolute; width: 350px; height: 450px">
      <ZernikeSettingsView></ZernikeSettingsView>
    </div>
    <div :style="`position:absolute;left:${dispW - 490}px;border:1px solid gray`">
      <MapForm
        parentForm="zernike"
        :dispW="500"
        :dispH="400"
        :indexInForm="0"
        :isZernike="true"
        :mapValues="mapValues"
        :casePath="casePath"
        :mapIndexUI="5"
        :colorBarWidth="70"
        :colorBarHeight="400"
        :isSelectVisibleBoolen="false"
        :isColorBarVisible="true"
        :isTilteVisible="false"
      />
    </div>
    <zernike-chart
      name="right-sider"
      :dispW="445"
      :dispH="dispH"
      :style="`position:absolute;left:${dispW}px;`"
      :zernike="zernike"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ZernikeSettingsView from "./ZernikeSettingsView.vue";
import IconButton from "./IconButton.vue";
import ZernikePyramid from "./ZernikePyramid.vue";
import MapForm from "./MapForm.vue";
import ZernikeChart from "./ZernikeChart";
import Zernike from "../js/zernike";
import ZernikeConfig from "../config/zernike";
import { INVALID_1000, stopWaiting, isDataNotMinus1000 } from "../shared";
import { isTrue, isDefined } from "../../shared/utils";
import { TOPOGRAPHYEVENTS } from "../shared/events";
import EVENTS from "../../bus";
let zernike = new Zernike();
let result = false;
let loadingObj;
let timeoutwait;
let timeoutWait2;
export default {
  name: "Zernike",
  data() {
    return {
      casePath: "",
      zernike: zernike,
      needUpdate: false
    };
  },
  created() {
    this.casePath = this.$store.state.topography.casePath;
    result = zernike.initZernikeMod(this.casePath);
    if (isTrue(result)) {
      this.updateZernike();
    }
    if (!result) {
      this.setZernikeValues(null, true);
    }
  },
  methods: {
    ...mapActions({
      zernikeParamsChanged: "topography/zernikeParamsChanged",
      zernikViewParamsChanged: "topography/zernikViewParamsChanged"
    }),
    showWaiting() {
      this.$emit("show-waiting", this.$t("langcfg.txtProccessingData"));
    },
    updateZernike(init = false, changed = true) {
      result = zernike.udateRpZnkOrder(this.zernikeSet.order, this.zernikeSet.diameter);
      if (isTrue(result)) {
        let values = zernike.getUIParams();
        this.setZernikeValues(values, false, changed);
      }
      if (init && result === false) {
        this.setZernikeValues(null, true, changed);
      }
    },
    setZernikeValues(values, failed = false, changed = true) {
      this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtLoading"));
      let len = 45;
      for (let id = 0; id < len; id++) {
        this.zernikeParams.params[id].value = isTrue(failed)
          ? INVALID_1000
          : isDataNotMinus1000(values[id])
            ? values[id] * 1000
            : -1000;
        let zernikeConfig = new ZernikeConfig(this.zernikeSet);
        if (isDefined(zernikeConfig)) {
          this.zernikeParams.params[id].enabled = zernikeConfig.isEnabled(id);
        }
      }
      if (changed) {
        this.zernikeParamsChanged(this.zernikeParams);
      }
    },
    getIndexes() {
      let indexes = new Float64Array(66);
      indexes.fill(0);
      for (let i = 0; i < this.zernikeParams.params.length; i++) {
        let state =
          isTrue(this.zernikeParams.params[i].selected) &&
          isTrue(this.zernikeParams.params[i].enabled);
        indexes[i] = isTrue(state) ? 1 : 0;
      }
      return indexes;
    },
    update() {
      let indexes = this.getIndexes();
      result = zernike.calcZnkMap(indexes);

      if (isTrue(result)) {
        let maxPeak = zernike.getUIMaxXY();
        let meanRms = zernike.getUIZnkparaKeys(indexes);
        this.zernikViewParamsChanged({
          maxPeak: maxPeak,
          meanRms: meanRms
        });
        let mapdata = zernike.getUIColorMapData();

        if (isDefined(mapdata) && mapdata.result === 0) {
          this.$bus.$emit(TOPOGRAPHYEVENTS.znkDataChanged, {
            data: mapdata.data,
            cntVal: mapdata.cntVal,
            step: mapdata.cmStep
          });
        }
      }
    }
  },
  beforeDestroy() {
    clearTimeout(timeoutwait);
    clearTimeout(timeoutWait2);
  },
  computed: {
    ...mapGetters(["zernikeSet", "zernikeParams"])
  },
  watch: {
    zernikeParams: {
      handler: function () {
        result = zernike.udateRpZnkOrder(this.zernikeSet.order, this.zernikeSet.diameter);
        if (isTrue(result)) {
          let values = zernike.getUIParams();
          this.setZernikeValues(values, false, false);
        }
        this.update();
      },
      deep: true
    },
    "zernikeSet.diameter": function () {
      result = zernike.udateRpZnkOrder(this.zernikeSet.order, this.zernikeSet.diameter);
      if (!isTrue(result)) {
        return;
      }
      this.update();
    }
  },
  mounted() {
    this.$emit("hide-waiting");
  },
  props: {
    dispW: {
      type: Number,
      default: window.screen.width - 30 - 500
    },
    dispH: {
      type: Number,
      default: window.screen.height - 80 - 10
    },
    mapValues: {
      type: Object
    },
    value: Boolean
  },
  components: {
    IconButton,
    MapForm,
    ZernikeSettingsView,
    ZernikePyramid,
    ZernikeChart
  },
  destroyed() {
    zernike.freeAberration();
  }
};
</script>
<style scoped>
.ratinal-image {
  width: 100%;
  height: 33.3%;
  border: 1px solid gray;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/Zernike.vue